export const
    QUIZZES_PENDING = 'quizzes_pending',
    QUIZZES_FAILED = 'quizzes_failed',
    QUIZZES_DOWNLOADED = 'quizzes_downloaded',
    QUIZ_DOWNLOADED = 'quiz_downloaded',
    QUIZ_DELETING = 'quiz_deleting',
    QUIZ_DELETED = 'quiz_deleted',
    QUIZ_EDITING = 'quiz_editing',
    QUIZ_RESET = 'quiz_reset',
    QUIZ_POSTING = 'quiz_posting',
    QUIZ_PICTURE_UPLOADING = 'quiz_picture_uploading',
    QUIZ_PICTURE_FAILED = 'quiz_picture_failed',
    QUIZ_QUESTION_DOWNLOADED = 'quiz_question_downloaded',
    QUIZ_QUESTION_PICTURE_UPLOADING = 'quiz_question_picture_uploading',
    QUIZ_QUESTION_PICTURE_FAILED = 'quiz_question_picture_failed';



// WEBPACK FOOTER //
// src/store/quizzes/types.js